<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    [mode]="isSmallScreen ? 'over' : 'side'"
    [opened]="!isSmallScreen"
    [disableClose]="!isSmallScreen"
  >
    <app-sidebar [isSmallScreen]="isSmallScreen"></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <!-- Topbar -->
    <app-navbar
      [isSmallScreen]="isSmallScreen"
      (toggleDrawer)="drawer.toggle()"
    ></app-navbar>
    <main class="flex-1 md:p-6 md:pt-0">
      <div
        class="w-full rounded-none md:rounded-2xl bg-[#424044] p-4 md:p-6 shadow"
      >
        <app-dashboard-cards></app-dashboard-cards>
        <router-outlet></router-outlet>
      </div>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Modals -->
@if (showAppForm) {
  <app-app-form
    [initialData]="appEditData"
    (formSubmit)="onAppSubmit($event)"
    (updateSubmit)="onAppEditSubmit($event)"
    (formClosed)="closeModalSuccess()"
  ></app-app-form>
}
@if (showUserForm) {
  <app-user-form
    [initialData]="userEditData"
    (createSubmit)="onUserSubmit($event)"
    (editSubmit)="onUserEditSubmit($event)"
    (cancelled)="closeModalSuccess()"
  ></app-user-form>
}

@if (showTeamForm) {
  <app-team-form
    [initialData]="teamEditData"
    (formSubmit)="onTeamSubmit($event)"
    (formClosed)="closeModalSuccess()"
  ></app-team-form>
}
